import { render, staticRenderFns } from "./EstatusArea.vue?vue&type=template&id=3fcf8764"
import script from "./EstatusArea.vue?vue&type=script&lang=js"
export * from "./EstatusArea.vue?vue&type=script&lang=js"
import style0 from "./EstatusArea.vue?vue&type=style&index=0&id=3fcf8764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports